import { IConversationTitle } from "Common/Interfaces";
import { CHAT_GROUPS, CHAT_GROUP_DAY_RANGES } from "./../Constants";
import { isToday, isWithinLastNDays, isYesterday } from "./DateRange";

export const groupConversationsByDateRange = (conversations: IConversationTitle[]) => {
  const groups = {
    [CHAT_GROUPS.TODAY]: [] as IConversationTitle[],
    [CHAT_GROUPS.YESTERDAY]: [] as IConversationTitle[],
    [CHAT_GROUPS.PREV_7_DAYS]: [] as IConversationTitle[],
    [CHAT_GROUPS.PREV_30_DAYS]: [] as IConversationTitle[],
    [CHAT_GROUPS.EARLIER]: [] as IConversationTitle[],
  };

  conversations.forEach((conversation) => {
    const conversationDate = new Date(conversation.modifiedOn);

    if (isToday(conversationDate)) {
      groups[CHAT_GROUPS.TODAY].push(conversation);
    } else if (isYesterday(conversationDate)) {
      groups[CHAT_GROUPS.YESTERDAY].push(conversation);
    } else if (isWithinLastNDays(conversationDate, CHAT_GROUP_DAY_RANGES.PREV_7_DAYS)) {
      groups[CHAT_GROUPS.PREV_7_DAYS].push(conversation);
    } else if (isWithinLastNDays(conversationDate, CHAT_GROUP_DAY_RANGES.PREV_30_DAYS)) {
      groups[CHAT_GROUPS.PREV_30_DAYS].push(conversation);
    } else {
      groups[CHAT_GROUPS.EARLIER].push(conversation);
    }
  });

  return groups;
};
